import { FC } from 'react'

import './ButtonHistory.scss'

interface Props {
    onClick?: () => void;
    light?: boolean;
    className?: string;
}

const ButtonHistory: FC<Props> = ({
    onClick,
    light = false,
    className = '',
}) => (
    <button
        type="button"
        className={
            `button-history
            ${light ? 'button-history--light' : ''} 
            ${className}
            `
        }
        onClick={onClick}
    >
        <svg width="21" height="18" viewBox="0 0 21 18" xmlns="http://www.w3.org/2000/svg">
            {/* eslint-disable-next-line max-len */}
            <path d="M12.5 5H11V10L15.28 12.54L16 11.33L12.5 9.25V5ZM12 0C9.61305 0 7.32387 0.948211 5.63604 2.63604C3.94821 4.32387 3 6.61305 3 9H0L3.96 13.03L8 9H5C5 7.14348 5.7375 5.36301 7.05025 4.05025C8.36301 2.7375 10.1435 2 12 2C13.8565 2 15.637 2.7375 16.9497 4.05025C18.2625 5.36301 19 7.14348 19 9C19 10.8565 18.2625 12.637 16.9497 13.9497C15.637 15.2625 13.8565 16 12 16C10.07 16 8.32 15.21 7.06 13.94L5.64 15.36C7.27 17 9.5 18 12 18C14.3869 18 16.6761 17.0518 18.364 15.364C20.0518 13.6761 21 11.3869 21 9C21 6.61305 20.0518 4.32387 18.364 2.63604C16.6761 0.948211 14.3869 0 12 0" />
        </svg>
    </button>
)

export default ButtonHistory
